import PropTypes from 'prop-types';
import { forwardRef } from 'react';

const TextBase = forwardRef(
  (
    {
      id,
      name,
      className = '',
      placeholder = '',
      isDefault = true,
      hasError = false,
      readOnly = false,
      rows = 3,
      ...props
    },
    ref,
  ) => {
    return (
      <textarea
        ref={ref}
        id={id}
        readOnly={readOnly}
        name={name}
        rows={rows}
        className={`
        input input-bordered
        input-sm
        w-full
        flex-1
        join-item
        ${className}
        ${!isDefault ? 'font-bold placeholder-shown:font-normal' : ''}
        ${hasError ? 'textarea-error' : ''}
      `}
        placeholder={placeholder}
        {...props}
      />
    );
  },
);

TextBase.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  isDefault: PropTypes.bool,
  readOnly: PropTypes.bool,
  hasError: PropTypes.bool,
  rows: PropTypes.number,
};

TextBase.displayName = 'TextBase';

export default TextBase;
